import { addStyles } from 'ethcss'
import { colors, IStyles, mediaCSS, palette } from '../../../theme'
import { color } from 'theme/tokens/color'

const monitorSettings: IStyles = {
    monitorsMode: {
        marginBottom: 30,
    },
    osType: {
        color: palette.brandBlue,
    },
    hint: {
        color: color.fontDarkMedium,
    },
    monitorsControlTitle: {
        marginBottom: 14,
    },
    monitorsControlScreenList: {
        marginTop: 10,
        display: 'flex',
    },
    screen: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10,
        borderRadius: 5,
        border: `1px solid ${colors.grey}`,
        overflow: 'hidden',
        width: 120,
        height: 70,
        marginRight: 6,
    },
    screenNumber: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 700,
        width: 24,
        height: 24,
        border: `1px solid ${colors.greyLight}`,
        borderRadius: '50%',
        lineHeight: 1,
    },
    screenMaster: {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: 8,
        backgroundColor: colors.blackLight,
    },
    masterScreenDropdown: {
        marginTop: 40,
        width: 350,
    },
    screenListWrapper: {
        marginTop: 30,
        overflow: 'hidden',
        borderRadius: '5px 5px 0 0',
    },
    screenListCaption: {
        padding: 10,
        fontWeight: 700,
        backgroundColor: colors.greyLight,
    },
    screenItem: {
        position: 'relative',
        padding: 10,
        display: 'flex',
        alignItems: 'center',
        borderBottom: `1px solid ${colors.greyLight}`,
        borderRight: `1px solid ${colors.greyLight}`,
        borderLeft: `1px solid ${colors.greyLight}`,
    },
    screenItemNumber: {
        marginRight: 14,
    },
    screenItemActionButton: {
        position: 'absolute',
        right: 10,
        top: '50%',
        transform: 'translateY(-50%)',
    },
    screenModal: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: 12000,
    },
    screenModalInner: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: colors.white,
        padding: 30,
        width: 640,
        borderRadius: 20,
    },
    screenModalCaptionWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    screenModalCaption: {
        marginRight: 20,
    },
    screenModalRow: {
        display: 'flex',
        padding: '20px 0',
        borderBottom: `1px solid ${colors.greyLight}`,
    },
    screenModalCol: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        //justifyContent: 'space-between',
        width: '50%',
        height: 40,
        position: 'relative',
    },
    buttons: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 30,
    },
    button: {
        display: 'flex',
        justifyContent: 'center',
        margin: '0 5px',
        minWidth: 90,
    },
    appViewType: {
        marginTop: 30,
    },
    appViewTypeRadio: {
        display: 'flex',
        marginTop: 14,
        marginBottom: 30,
    },
    byPixelSettings: {
        width: 530,

        [mediaCSS.tab]: {
            width: 320,
        },
    },
    byPixelSettingsRow: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 20,
    },
    byPixelInput: {
        width: '48%',
    },
    centering: {
        alignItems: 'center',
    },
    disabledScreen: {
        opacity: 0.5,
    },
    radio: {
        position: 'absolute',
        right: 6,
        top: 6,
        width: 20,
    },
    vertical: {
        transform: 'rotate(90deg)',

        ':first-child': {
            left: 0,
            bottom: 0,
            top: 0,
            right: 'auto',
            width: 8,
            height: '100%',
        },

        ':last-child': {
            transform: 'rotate(-90deg)',
        },
    },
    dropdownWrapper: {
        position: 'absolute',
        right: 0,
        top: 0,
        width: '100%',
    },
    tooltip: {
        marginTop: 10,
    },
    actualization: {
        marginTop: 30,
    },
    actualizationTitle: {
        marginBottom: 10,
    },
}

addStyles(monitorSettings)
export default monitorSettings
